import React, {useEffect, useState} from "react";

export default function DatePicker(props){
    const [value, setValue] = useState(props.value)
    useEffect(()=>{
        setValue(props.value)
    }, [props.value])
    function renderCalendar(){
        // if(!isOpen) return null
        return <>
            {props.label ? <label>{props.label}</label> : null}
            <input
                type={"date"} //type="datetime-local" jos halutaan asettaa aika
                name="start"
                placeholder={"pp.kk.vvvv"}
                value={value}
                onChange={evt => {
                    setValue(evt.target.value)
                    props.onChange(evt)
                }}
                className={"btn btn-md btn-2nd"}
                min={props.minDate}
                max={props.maxDate}
            />
        </>
    }

    return <div className={"ui-datepicker label-set" + (props.className ? " " + props.className : "")}>
        {renderCalendar()}
    </div>
}